import { render, staticRenderFns } from "./BaseCardHover.vue?vue&type=template&id=5ed3558e&scoped=true&"
import script from "./BaseCardHover.vue?vue&type=script&lang=js&"
export * from "./BaseCardHover.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardHover.vue?vue&type=style&index=0&id=5ed3558e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3558e",
  null
  
)

export default component.exports